import { render, staticRenderFns } from "./ExpandingControlBox.vue?vue&type=template&id=3584cbe8&scoped=true"
import script from "./ExpandingControlBox.vue?vue&type=script&lang=js"
export * from "./ExpandingControlBox.vue?vue&type=script&lang=js"
import style0 from "./ExpandingControlBox.vue?vue&type=style&index=0&id=3584cbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584cbe8",
  null
  
)

export default component.exports